import { render, staticRenderFns } from "./shengchan.vue?vue&type=template&id=604a8312&scoped=true&"
import script from "./shengchan.vue?vue&type=script&lang=js&"
export * from "./shengchan.vue?vue&type=script&lang=js&"
import style0 from "./shengchan.vue?vue&type=style&index=0&id=604a8312&lang=scss&scoped=true&"
import style1 from "./shengchan.vue?vue&type=style&index=1&id=604a8312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a8312",
  null
  
)

export default component.exports